import React, {Suspense, useState} from 'react';
import {createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider,} from 'react-router-dom';
import {action as requestPasswordAction} from 'components/RequestPasswordForm/RequestPasswordForm';
import {action as resetPasswordAction, loader as resetPasswordLoader} from 'components/ResetPasswordForm/ResetPasswordForm';
import {action as loginAction} from 'components/LoginForm/LoginForm';
import {findReportsAction} from 'components/FindVinForm/FindVinForm';
import {CircularProgress, createTheme, Grid, ThemeProvider} from '@mui/material';
import {localesInit} from 'locales/LocalesInit';
import RouteAuthenticator from './components/RouteAuthenticator/RouteAuthenticator';
import ErrorComponent from "./components/RouteAuthenticator/ErrorComponent";
import {ReportsPageByVinAndWan} from "./pages/reports/ReportsPageByVinAndWan";
import {FindVinFormDataProvider} from "./components/FindVinForm/FindVinFormDataProvider";
import FormPage from "./pages/FormPage";

const ErrorPage = React.lazy(() => import('pages/ErrorPage'));
const LoginForm = React.lazy(() => import('components/LoginForm/LoginForm'));
const RequestPasswordSideForm = React.lazy(() => import('components/SideForm/RequestPasswordSideForm'));
const ResetPasswordSideForm = React.lazy(() => import('components/SideForm/ResetPasswordSideForm'));
const FindVinSideForm = React.lazy(() => import('components/SideForm/FindVinSideForm'));
const ReportsPage = React.lazy(() => import( 'pages/reports/ReportsPage'));
const PrivacyPolicyPage = React.lazy(() => import('pages/PrivacyPolicyPage'));

localesInit();

const theme = createTheme({
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    color: '#444854', //Mako
                    '.MuiInputBase-root:hover:not(.Mui-focused):not(Mui-error)': {
                        color: '#6D7881', //Pale sky
                    },
                    '.MuiInputBase-root.Mui-error': {
                        backgroundColor: '#FFE1E4',
                    },
                    '.MuiInputBase-root.Mui-focused': {
                        backgroundColor: '#FFF9EE',
                    },
                },
            },
        },
    },
});
const App = () => {

    const [selectedDatabases, setSelectedDatabases] = useState([]);

    const token = localStorage.getItem('token');

    const router = createBrowserRouter(createRoutesFromElements(
        <Route element={<RouteAuthenticator/>} errorElement={<ErrorComponent/>}>
            <Route path={'/'} element={<Navigate to={token ? '/find-vin' : '/login'} replace/>}/>
            <Route element={<FormPage isLogoutButtonVisible={false}/>}>
                <Route path={'/login'} element={<LoginForm/>} action={loginAction}/>
                <Route path={'/request-password'} element={<RequestPasswordSideForm/>}
                       action={requestPasswordAction}/>
                <Route path={'/recover/:token'} element={<ResetPasswordSideForm/>}
                       loader={resetPasswordLoader} action={resetPasswordAction}/>
            </Route>
            <Route element={<FindVinFormDataProvider/>}>
                <Route element={<FormPage isLogoutButtonVisible={true}/>}>
                    <Route path={'/find-vin'} element={<FindVinSideForm selectedDatabases={selectedDatabases}
                                                                        setSelectedDatabases={setSelectedDatabases}
                    />}
                           action={findReportsAction()}/>
                </Route>
            </Route>
            <Route path={'/reports'} action={findReportsAction()}
                   element={<ReportsPage selectedDatabases={selectedDatabases}
                                         setSelectedDatabases={setSelectedDatabases}/>}
            />
            <Route path={'/pages/singleResult'} action={findReportsAction()}
                   element={<ReportsPage selectedDatabases={selectedDatabases}
                                         setSelectedDatabases={setSelectedDatabases}/>}/>
            <Route path={'/pages/selectedResult'}
                   element={<ReportsPageByVinAndWan setSelectedDatabases={setSelectedDatabases}/>}/>
            <Route path={'/privacy-policy'} element={<PrivacyPolicyPage />} />
            <Route path={'*'} element={<ErrorPage/>}/>
        </Route>
    ));

    return (
        <Suspense fallback={<div className={'centered'}><CircularProgress size={150}/></div>}>
            <ThemeProvider theme={theme}>
                <Grid container>
                    <RouterProvider router={router}/>
                </Grid>
            </ThemeProvider>
        </Suspense>
    );
};

export default App;
